import { useState, useEffect } from "react";
import { db } from "./../firebase/firebaseConfig";
import { useAuth } from "./../contextos/AuthContext";

const useObtenerGastos = () => {
  const { usuario } = useAuth();

  const [gastos, cambiarGastos] = useState([]);
  //optener ultimo gasto
  const [ultimoGasto, cambiarUltimoGasto] = useState(null);
  const [hayMasPorCargar, cambiarHayMasPorCargar] = useState(false);

  //obtener mas gastos de bbdd
  const obtenerMasGastos = () => {
    db.collection("gastos")
      .where("uidUsuario", "==", usuario.uid)
      .orderBy("fecha", "desc")
      .limit(7)
      .startAfter(ultimoGasto)
      .onSnapshot(snapshot => {
        if (snapshot.docs.length > 0) {
          cambiarUltimoGasto(snapshot.docs[snapshot.docs.length - 1]);

          cambiarGastos(
            gastos.concat(
              snapshot.docs.map(gasto => {
                return { ...gasto.data(), id: gasto.id };
              })
            )
          );
        } else {
          cambiarHayMasPorCargar(false);
        }
      });
  };

  useEffect(() => {
    const unsuscribe = db
      .collection("gastos")
      .where("uidUsuario", "==", usuario.uid)
      .orderBy("fecha", "desc")
      .limit(7)
      .onSnapshot(snapshot => {
        //console.log(snapshot.docs);
        //console.log(snapshot.docs[snapshot.docs.length -1].data())
        if (snapshot.docs.length > 0) {
          cambiarUltimoGasto(snapshot.docs[snapshot.docs.length - 1]);
          cambiarHayMasPorCargar(true);
        } else {
          cambiarHayMasPorCargar(false);
        }

        cambiarGastos(
          snapshot.docs.map(gasto => {
            //console.log(gasto.data());
            return { ...gasto.data(), id: gasto.id };
          })
        );
      });
    //limpia la consulta - cierra la consulta
    return unsuscribe;
  }, [usuario]);
  //retorna el array de gastos
  return [gastos, obtenerMasGastos, hayMasPorCargar];
};

export default useObtenerGastos;
